const domify = require('domify');

class PartnersSlider {
  constructor(element) {
    this.element = element;
    this.elementParent = this.element.parentElement;
    if (this.element.clientWidth > this.elementParent.clientWidth) {
      this.duplicate();
      this.animate();
    }
  }

  duplicate() {
    const duplicatedElement = this.element.cloneNode(true);
    this.elementParent.appendChild(duplicatedElement);
  }

  animate() {
    const animationSet = domify(['-o-', '-webkit-', '-moz-', ''].map((i) => `
        <style>
          @${i}keyframes marquee {
            0% {transform: translateX(0)}
            100% {transform: translateX(-${this.element.clientWidth}px)}
          }

          .nyt-partners-holder {
            animation: ${this.getLoopDuration()}s linear infinite marquee;
          }
        </style>
      `).join(''));

    document.body.appendChild(animationSet);
  }

  getLoopDuration() {
    const childrenLength = this.element.childNodes.length;
    return childrenLength * 2.5;
  }
}

module.exports = {
  PartnersSlider,
};
